export default "__VITE_ASSET__DJnF4uBg__"